import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=cb1f45f0&scoped=true&"
import script from "./prescription.vue?vue&type=script&lang=js&"
export * from "./prescription.vue?vue&type=script&lang=js&"
import style0 from "./prescription.vue?vue&type=style&index=0&id=cb1f45f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1f45f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1f45f0')) {
      api.createRecord('cb1f45f0', component.options)
    } else {
      api.reload('cb1f45f0', component.options)
    }
    module.hot.accept("./prescription.vue?vue&type=template&id=cb1f45f0&scoped=true&", function () {
      api.rerender('cb1f45f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/prescription.vue"
export default component.exports